import React, { useState, useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { useThemeMode } from '../hooks/useThemeMode';
import IntroAnimation from '../components/landing/IntroAnimation';
import Navbar from '../components/landing/Navbar';
import Hero from '../components/landing/Hero';
import StatsBar from '../components/landing/StatsBar';
import HowItWorks from '../components/landing/HowItWorks';
import Features from '../components/landing/Features';
import Chains from '../components/landing/Chains';
import Architecture from '../components/landing/Architecture';
import AgentSection from '../components/landing/AgentSection';
import Footer from '../components/landing/Footer';

const Landing = () => {
  const [loading, setLoading] = useState(true);
  const { isDark } = useThemeMode();

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2800);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div
      className="internull-landing min-h-screen selection:bg-white selection:text-black"
      style={{
        backgroundColor: isDark ? '#050505' : '#fafafa',
        color: isDark ? '#e5e5e5' : '#171717',
        fontFamily: 'Inter, sans-serif',
      }}
    >
      <AnimatePresence mode="wait">
        {loading ? (
          <IntroAnimation key="intro" />
        ) : (
          <motion.div
            key="content"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            className="relative z-10"
          >
            <Navbar />
            <main>
              <Hero />
              <StatsBar />
              <HowItWorks />
              <Chains />
              <Features />
              <Architecture />
              <AgentSection />
            </main>
            <Footer />
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default Landing;
